import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import "./EmailVerify.css";

const USERS_BASE_URL = import.meta.env.VITE_USERS_BASE_URL;

function EmailVerify() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleNext = async () => {
    try {
      const response = await fetch(`${USERS_BASE_URL}/check-email/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
        email,
        site_name: import.meta.env.VITE_SITE_NAME
        })
      });
      
      const data = await response.json();
       
      if (data.exists) {
        navigate("/login", { state: { email } });
      } else {
        navigate("/register", { state: { email } });
      }
    } catch (error) {
      setError("A server error occurred.");
    }
  };

  const goToRegister = () => {
    navigate("/register");
  };

  return (
    <div className="container">
      <div className="form-card">
        <img src={logo} alt="App Logo" className="logo" />
        <label className="label">
          <h2>Sign in</h2>
          <p>to the Discussion Forum</p>
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="input"
        />
        <button onClick={handleNext} className="button" disabled={!email}>
          Next
        </button>
        {error && <div className="error-message">{error}</div>}
        <p className="text">
          Do you have an account?{" "}
          <span autoComplete="off" onClick={goToRegister} className="link">
            Register
          </span>
        </p>
      </div>
    </div>
  );
}

export default EmailVerify;
